'use client';

import { LoginProviderButton } from '@/components/login/LoginProviderButton';
import { ROUTES } from '@/configs/routes';
import { useRouter } from '@/i18n/navigation';
import { LockKeyholeIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';

const OTPProvider = () => {
  const router = useRouter();
  const t = useTranslations('LoginPage');

  const handleOTPClick = () => {
    router.push({ pathname: ROUTES.LOGIN, query: { provider: 'otp' } });
  };

  return (
    <LoginProviderButton logo={<LockKeyholeIcon />} isPending={false} onClick={handleOTPClick}>
      {t('emailOtpTab')}
    </LoginProviderButton>
  );
};

export default OTPProvider;
